import React from "react";
import { PHOTOS_GET } from "../../api";
import useFetch from "../../Hooks/useFetch";
import FeedPhotoItem from "./FeedPhotosItem";
import Error from "../Helper/Error";
import Loading from "../Helper/Loading";
import styles from "./FeedPhotos.module.css";

function FeedPhotos({ setModalPhoto, setInfinite, user, page }) {
	const { data, error, loading, request } = useFetch();

	React.useEffect(() => {
		async function fetchPhotos() {
			const total = 6;
			const { url, options } = PHOTOS_GET({ page, total, user });
			const { response, json } = await request(url, options);

			if (response && response.ok && json.length < total) setInfinite(false);
		}
		fetchPhotos();
	}, [request, user, page]);

	if (error) return <Error error={error} />;
	if (loading) return <Loading />;
	if (data)
		return (
			<ul className={`${styles.feed} animeLeft`}>
				{data.map((photo) => (
					<FeedPhotoItem
						key={photo.id}
						photo={photo}
						setModalPhoto={setModalPhoto}
					/>
				))}
			</ul>
		);
	else return null;
}

export default FeedPhotos;
